<template lang="pug">
section.is-hidden-tablet(v-bind:class="sectionClass" v-if="!accessToken")
	.section-content
		.has-text-centered(style="margin-bottom: 1.2em; margin-top: -.2em")
			| {{ $t("menu.promo_code") }}
		.columns.is-centered.is-vcentered.is-mobile(style="margin-bottom: 1.2em;")
			//-a.button.is-primary.is-jtwia(@click="goPromoCode" style="margin: .2em;")
				.navbar-partner-logo
					img(src="/img/jtwia_small.png"
						style="display:block;max-height:2em; margin-top:-.1rem;")
			//-a.button.is-primary.is-vodafone(@click="goPromoCode" style="margin: .2em;")
				.navbar-partner-logo
					img(src="/img/vodafone_business_small.png"
						style="display:block;max-height:2em; margin-top:-.1rem;")
			//-a.button.is-primary.is-fastweb(@click="goPromoCode" style="margin: .2em;")
				.navbar-partner-logo
					img(src="/img/fastweb_small.png"
						style="display:block;max-height:2em; margin-top:-.1rem;")
			//-a.button.is-primary.is-agos(@click="goPromoCode" style="margin: .2em;")
				.navbar-partner-logo
					img(src="/img/agos_small.png"
						style="display:block;max-height:2em; margin-top:-.1rem;")
			a.button.is-primary(@click="goPromoCode" style="margin: .2em;")
				| {{ $t("auth.enter_promo") }}
</template>

<script>
import { ChevronRightIcon } from 'vue-feather-icons'

export default {
	name : 'SectionCode',
	components: {
		ChevronRightIcon
	},
	props: {
		num: Number
	},
	computed: {
		accessToken() {
			return this.$store.state.auth.accessToken
		},
		sectionClass() {
			return {
				'section'                : true,
				'border-bottom-section'  : true,
				'section-background-grey': this.num % 2 === 0
			}
		}
	},
	methods: {
		goPromoCode() {
			this.$router.push('/' + this.$route.params.language + '/promo-code')
		}
	}
}
</script>
